'use client';

import { usePathname } from 'next/navigation';
import {
  resolveBreadcrumbs,
  shouldShowBreadcrumbs,
} from '@/lib/seo/breadcrumbs';
import type { BreadcrumbItem } from '@/lib/seo/schemas';
import { PageBreadcrumbs } from './PageBreadcrumbs';
import type { BreadcrumbVariant } from './Breadcrumbs';

interface AutoBreadcrumbsProps {
  /** Override the final segment label for dynamic pages. */
  currentLabel?: string;
  /** Pass explicit items to skip auto-resolution. */
  items?: BreadcrumbItem[];
  variant?: BreadcrumbVariant;
  className?: string;
  schemaId?: string;
}

export function AutoBreadcrumbs({
  currentLabel,
  items,
  variant = 'default',
  className = '',
  schemaId,
}: AutoBreadcrumbsProps) {
  const pathname = usePathname();

  if (!pathname || !shouldShowBreadcrumbs(pathname)) return null;

  const resolved = items ?? resolveBreadcrumbs(pathname, currentLabel);
  if (resolved.length <= 1) return null;

  return (
    <PageBreadcrumbs
      items={resolved}
      variant={variant}
      className={className}
      schemaId={schemaId}
    />
  );
}
